import React, { useEffect, useState } from 'react';
//import { FaCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import {
  fieldObjectProdutosDaf,
  headersProdutos as headersTable,
  valoresExibidosProdutos as valoresExibidos,
} from './auxiliarProdutosDaf';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
//import Button from '../../../../components/Button';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import CustomSpan from '../../../../components/CustomSpan';
import Input from '../../../../components/InputNew';
import Select from '../../../../components/InputNew/Select';
import Tabela from '../../../../components/Tabela';
import ToggleSwitch from '../../../../components/ToggleSwitch';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import BolinhaTabelaStatus from '../../../../components/bolinhaTabelaStatus';
import {
  getUser,
  isActionAllowed,
} from '../../../../modules/contexts/Auth/RequireAuth';
import { useAcondicionamento } from '../../../../services/enum/useAcondicionamento';
// import { useGrupoFinanciamento } from '../../../../services/enum/useGrupoFinanciamento';
import { useGrupoFinanciamento } from '../../../../services/enum/useGrupoFinanciamento';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';
import { useTipoProduto } from '../../../../services/enum/useTipoProduto';
import { useUmidadeProduto } from '../../../../services/enum/useUmidadeProduto';
import { useListaDenominacoesGenericas } from '../../../../services/produtosDAF/denominacoesGenericasService';
import { getAllProdutos as getAll } from '../../../../services/produtosDAF/produtosDafService';
import { ENTITY } from '../../../../utils/entityNames';
import { ExportToExcel } from '../../../../utils/functions';
import SubAbas from '../subabas';

//DADOS USUARIO
const user = getUser();
const userID = user.sub;
const entity = ENTITY.ENTITY_Faq;
// Definição do Cache
const CACHE_KEY = 'cachedProdutos';
const CACHE_EXPIRATION = 60 * 60 * 1000; // 5 minutos

const ProdutosIndex: React.FC = () => {
  //PERMISSOES
  const papelUsuarioOptions = usePapelUsuario();
  const moduloUsuarioOptions = useModuloUsuario();

  const grupoFinanciamento = useGrupoFinanciamento();

  // Obter o módulo
  const MODULO = Number(
    moduloUsuarioOptions.find(
      (modulo) => modulo.label === 'Produtos Farmacêuticos',
    )?.value || '0',
  );

  // Verificar permissões para ações
  const canDownload = isActionAllowed(MODULO, 'read', papelUsuarioOptions);
  const canInsert = isActionAllowed(MODULO, 'create', papelUsuarioOptions);
  //PERMISSOES

  const navigate = useNavigate();
  const tipoProduto = useTipoProduto();
  const acondicionamentoProduto = useAcondicionamento();
  const umidadeProduto = useUmidadeProduto();
  const listaDenominacoesGenericas = useListaDenominacoesGenericas();
  const theme = useTheme();

  //Filtro
  const [formFiltros, setFormFiltros] = useState({
    tipoProduto: 0,
    grupoEspecializado: 0,
    status: 'S' as 'S' | 'N' | null,
    basico: null as 'S' | 'N' | null,
    especializado: null as 'S' | 'N' | null,
    estrategico: null as 'S' | 'N' | null,
    produtoFarmaceutico: '',
    tag: '',
  });

  const [data, setData] = useState<any[]>([]);

  // Buscar dados com cache

  const fetchData = async () => {
    try {
      const cachedData = localStorage.getItem(CACHE_KEY);
      const now = new Date().getTime();

      if (cachedData) {
        const { timestamp, data } = JSON.parse(cachedData);
        const timeDifference = now - timestamp;

        if (timeDifference < CACHE_EXPIRATION) {
          setData(data);
          return;
        } else {
          localStorage.removeItem(CACHE_KEY);
        }
      }

      // Buscar novos dados
      const registros = await getAll();
      setData(registros);

      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ timestamp: now, data: registros }),
      );
    } catch (error) {
      console.error(' Erro ao obter dados:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const tableData = data
    .filter((item: any) => {
      return (
        (formFiltros.tipoProduto === 0 ||
          item.denominacaoGenerica?.tipoProduto === formFiltros.tipoProduto) &&
        (formFiltros.grupoEspecializado === 0 ||
          item.especializadoGrupo === Number(formFiltros.grupoEspecializado)) &&
        (formFiltros.status === 'S' ||
          item.statusDistribuicao === formFiltros.status) &&
        (formFiltros.basico === null ||
          item.compBasico === formFiltros.basico) &&
        (formFiltros.especializado === null ||
          item.compEspecializado === formFiltros.especializado) &&
        (formFiltros.estrategico === null || // Se oncológico for null, não filtra
          item.compEstrategico === formFiltros.estrategico) &&
        (formFiltros.produtoFarmaceutico === '' ||
          (item.produtoFarmaceutico &&
            item.produtoFarmaceutico
              .toLowerCase()
              .includes(formFiltros.produtoFarmaceutico.toLowerCase()))) &&
        (formFiltros.tag === '' ||
          (item.tags &&
            item.tags
              .toLowerCase()
              .split(/[\s,]+/) // Divide as tags por espaços ou vírgulas
              .some((t: string) => t.includes(formFiltros.tag.toLowerCase()))))
      );
    })
    .map((item) => {
      // Obtendo tipoProduto de forma segura
      const tipoProdutoInfo =
        item?.denominacaoGenerica?.tipoProduto !== undefined &&
        tipoProduto?.[item.denominacaoGenerica.tipoProduto]
          ? tipoProduto[item.denominacaoGenerica.tipoProduto].label
          : 'Não informado';

      return {
        id: item?.id ?? 'Não informado',
        status: (
          <BolinhaTabelaStatus status={item?.statusDistribuicao ?? 'N'} />
        ),
        tipoProduto: tipoProdutoInfo,
        compBasico: <BolinhaTabelaStatus status={item?.compBasico ?? 'N'} />,
        compEspecializado: (
          <BolinhaTabelaStatus status={item?.compEspecializado ?? 'N'} />
        ),
        compEstrategico: (
          <BolinhaTabelaStatus status={item?.compEstrategico ?? 'N'} />
        ),
        produtoFarmaceutico: item?.produtoFarmaceutico ?? 'Não informado',
        tags: item?.tags ?? 'Não informado',
      };
    });

  //Dados do Offcanvas
  const offCanvasData = data.map((item) => {
    // Obtendo tipoProduto de forma segura
    const tipoProdutoInfo =
      item?.denominacaoGenerica?.tipoProduto !== undefined &&
      tipoProduto?.[item.denominacaoGenerica.tipoProduto]
        ? tipoProduto[item.denominacaoGenerica.tipoProduto].label
        : 'Não informado';

    const statusRenameNumber = item.statusRename;

    let statusRenameLabel = '';
    let statusBackgroundColor = '';
    if (statusRenameNumber === 1) {
      statusBackgroundColor = theme.colors.amarelo;
      statusRenameLabel = 'Não publicado';
    } else if (statusRenameNumber === 2) {
      statusBackgroundColor = theme.colors.verde;
      statusRenameLabel = 'Publicado';
    } else if (statusRenameNumber === 3) {
      statusBackgroundColor = theme.colors.azul;
      statusRenameLabel = 'Ampliação de uso';
    } else if (statusRenameNumber === 4) {
      statusBackgroundColor = theme.colors.vermelho;
      statusRenameLabel = 'Excluído';
    }

    return {
      id: item?.id ?? 'Não informado',
      produto: <b>{item?.produtoFarmaceutico ?? 'Não informado'}</b>,
      tipoProduto: tipoProdutoInfo,
      codigoAtc: item.codigoAtc,
      umidade: umidadeProduto?.[item.umidade]?.label ?? 'Não informado',
      acondicionamento:
        acondicionamentoProduto?.[item.acondicionamento]?.label ??
        'Não informado',
      oncologico: item?.oncologico === 'S' ? 'Sim' : 'Não',
      biologico: item?.biologico === 'S' ? 'Sim' : 'Não',
      status:
        item?.statusDistribuicao === 'S' ? (
          <CustomSpan texto="Ativo" />
        ) : (
          <CustomSpan texto="Inativo" />
        ),
      statusRename: (
        <div
          style={{
            textAlign: 'left',
            justifySelf: 'flex-start',
            marginLeft: '0px',
          }}
        >
          <span
            style={{
              backgroundColor: statusBackgroundColor,
              borderRadius: '10px',
              padding: '10px',
              color: 'white',
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {statusRenameLabel}
          </span>
        </div>
      ),
      compBasico:
        item?.compBasico === 'S' ? (
          <CustomSpan texto="Sim" />
        ) : (
          <CustomSpan texto="Não" />
        ),
      compEspecializado:
        item?.compEspecializado === 'S' ? (
          <CustomSpan texto="Sim" />
        ) : (
          <CustomSpan texto="Não" />
        ),
      grupoEspecializado:
        grupoFinanciamento?.[item.especializadoGrupo]?.label ?? 'Não se aplica',
      compEstrategico:
        item?.compEstrategico === 'S' ? (
          <CustomSpan texto="Sim" />
        ) : (
          <CustomSpan texto="Não" />
        ),
      usoHospitalar:
        item?.usoHospitalar === 'S' ? (
          <CustomSpan texto="Sim" />
        ) : (
          <CustomSpan texto="Não" />
        ),
      farmaciaPopular:
        item?.farmaciaPopular === 'S' ? (
          <CustomSpan texto="Sim" />
        ) : (
          <CustomSpan texto="Não" />
        ),
      tags: item?.tags || 'Não informado',
      observacoes: item?.observacoes || 'Não informado',
    };
  });

  // Funções Handle
  const handleClearFiltros = () => {
    setFormFiltros({
      ...formFiltros,
      tipoProduto: 0,
      grupoEspecializado: 0,
      status: 'S' as 'S' | 'N' | null,
      basico: null as 'S' | 'N' | null,
      especializado: null as 'S' | 'N' | null,
      estrategico: null as 'S' | 'N' | null,
      produtoFarmaceutico: '',
    });
  };

  const handleChange = (e: any | 'S' | 'N' | null, fieldName?: string) => {
    if (typeof e === 'string') {
      // Lidando com os campos booleanos (status, oncologico, biologico)
      setFormFiltros((prev) => ({
        ...prev,
        [fieldName ?? 'defaultFieldName']: e,
      }));
    } else {
      const { name, value } = e.target;
      setFormFiltros((prev) => ({
        ...prev,
        [name]: name === 'tipoProduto' ? parseInt(value, 10) : value,
      }));
    }
  };

  const handleClickInserir = () => {
    navigate('ficha/dadosgerais');
  };

  interface ExportData {
    id: number;
    dataRegistro: string;
    usuarioRegistro: {
      nomeCompleto: string;
    };
    dataUltimaAtualizacao: string;
    usuarioAtualizacao: {
      nomeCompleto: string;
    };
    dataUltimaVisualizacao: string;
    usuarioUltimaVisualizacao: {
      nomeCompleto: string;
    };
    nEdicoes: number;
    nVisualizacoes: number;
    nVisualizadores: number;

    //Específicos
    denominacaoGenerica: {
      id: number;
    };
    tipoProduto: string;
    atcId: number;
    aware: number;
    formaFarmaceutica: number;
    formaFarmaceuticaSimp: number;
    formaFarmaceuticaLabel: string;
    umidade: number;
    acondicionamento: number;
    produtoFarmaceutico: string;
    concentracao: string;
    oncologico: string;
    biologico: string;
    statusDistribuicao: string;
    compBasico: string;
    compEspecializado: string;
    compEstrategico: string;
    grupoEspecializado: string;
    usoHospitalar: string;
    farmaciaPopular: string;
    sigtapPossui: string;
    sigtapCodigo: string;
    sigtapNome: string;
    sismatPossui: string;
    sismatCodigo: string;
    sismatNome: string;
    catmatPossui: string;
    catmatCodigo: string;
    catmatNome: string;
    obmPossui: string;
    obmCodigo: string;
    obmNome: string;
    tags: string;
    tagsArray: {
      tag: string;
    };

    //Observações
    observacoes: string;
  }

  const filteredDataForExport = data.filter((item) => {
    return (
      (formFiltros.tipoProduto === 0 ||
        item.denominacaoGenerica?.tipoProduto === formFiltros.tipoProduto) &&
      (formFiltros.status === 'S' ||
        item.statusDistribuicao === formFiltros.status) &&
      (formFiltros.basico === null || item.compBasico === formFiltros.basico) &&
      (formFiltros.especializado === null ||
        item.compEspecializado === formFiltros.especializado) &&
      (formFiltros.estrategico === null || // Se oncológico for null, não filtra
        item.compEstrategico === formFiltros.estrategico) &&
      (formFiltros.produtoFarmaceutico === '' ||
        (item.produtoFarmaceutico &&
          item.produtoFarmaceutico
            .toLowerCase()
            .includes(formFiltros.produtoFarmaceutico.toLowerCase()))) &&
      (formFiltros.tag === '' ||
        (item.tag &&
          item.tag.toLowerCase().includes(formFiltros.tag.toLowerCase())))
    );
  });

  const prepareDataForExport = (data: ExportData[]) => {
    return data.map((item) => {
      const tipoProdutoNumber = listaDenominacoesGenericas.find(
        (registro) => registro.id === item.denominacaoGenerica.id, // Ajuste aqui para usar denominacaoGenericaId
      )?.tipoProduto;

      return {
        id: item.id,

        //Logs
        dataRegistro: item.dataRegistro,
        usuarioRegistro: item.usuarioRegistro.nomeCompleto,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao,
        usuarioAtualizacao: item.usuarioAtualizacao.nomeCompleto,
        dataUltimaVisualizacao: item.dataUltimaVisualizacao,
        usuarioUltimaVisualizacao: item.usuarioUltimaVisualizacao.nomeCompleto,
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        nVisualizadores: item.nVisualizadores,

        // Específicos
        tipoProduto: tipoProdutoNumber
          ? tipoProduto[tipoProdutoNumber]?.label || 'Não informado'
          : 'Não informado',
        denominacaoGenerica:
          listaDenominacoesGenericas.find(
            (registro) => registro.id === item.denominacaoGenerica.id, // Ajuste para usar denominacaoGenericaId
          )?.denominacao || 'Não informado',
        produtoFarmaceutico: item.produtoFarmaceutico || 'Não informado',
        compBasico: item.compBasico === 'S' ? 'Sim' : 'Não',
        compEspecializado: item.compEspecializado === 'S' ? 'Sim' : 'Não',
        compEstrategico: item.compEstrategico === 'S' ? 'Sim' : 'Não',
        oncologico: item.oncologico === 'S' ? 'Sim' : 'Não',
        biologico: item.biologico === 'S' ? 'Sim' : 'Não',
        usoHospitalar: item.usoHospitalar === 'S' ? 'Sim' : 'Não',
        farmaciaPopular: item.farmaciaPopular === 'S' ? 'Sim' : 'Não',
        sigtap:
          item.sigtapCodigo !== ''
            ? `${item.sigtapCodigo} ${item.sigtapNome}`
            : 'Não informado',
        sismat:
          item.sismatCodigo !== ''
            ? `${item.sismatCodigo} ${item.sismatNome}`
            : 'Não informado',
        catmat:
          item.catmatCodigo !== ''
            ? `${item.catmatCodigo} ${item.catmatNome}`
            : 'Não informado',
        obm:
          item.obmCodigo !== ''
            ? `${item.obmCodigo} ${item.obmNome}`
            : 'Não informado',
        tags: item.tags || 'Não informado',

        //Observações
        observacoes: item.observacoes,
      };
    });
  };

  return (
    <>
      <BarraSubAbas subAbas={SubAbas} />

      <ContainerConteudo>
        <BoxConteudo boxTitulo="Filtros">
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="15%">
              <Select
                name="tipoProduto"
                value={formFiltros.tipoProduto}
                options={tipoProduto}
                onChange={handleChange}
                label="Tipo de Produto"
              />
            </CustomCol>
            <CustomCol width="7%">
              <ToggleSwitch
                label="Status"
                value={formFiltros.status}
                onChange={(newValue) => handleChange(newValue, 'status')}
              />
            </CustomCol>
            <CustomCol width="7%">
              <ToggleSwitch
                label="Básico"
                value={formFiltros.basico}
                onChange={(newValue) => handleChange(newValue, 'basico')}
              />
            </CustomCol>
            <CustomCol width="7%">
              <ToggleSwitch
                label="Especializado"
                value={formFiltros.especializado}
                onChange={(newValue) => handleChange(newValue, 'especializado')}
              />
            </CustomCol>
            <CustomCol width="7%">
              <ToggleSwitch
                label="Estratégico"
                value={formFiltros.estrategico}
                onChange={(newValue) => handleChange(newValue, 'estrategico')}
              />
            </CustomCol>
            <CustomCol width="15%">
              <Select
                name="grupoEspecializado"
                value={formFiltros.grupoEspecializado}
                options={grupoFinanciamento}
                onChange={handleChange}
                label="Grupo Financiamento"
              />
            </CustomCol>
            <CustomCol>
              <Input
                id="produtoFarmaceutico"
                name="produtoFarmaceutico"
                value={formFiltros.produtoFarmaceutico}
                label="Produto Farmacêutico"
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol>
              <Input
                id="tag"
                name="tag"
                value={formFiltros.tag}
                label="Tag"
                onChange={handleChange}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080" // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>

        <Tabela
          headers={headersTable}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidos}
          tituloCanvas="PRODUTO DAF"
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          downloadDisabled={!canDownload}
          onClickDownload={() =>
            ExportToExcel(
              prepareDataForExport(filteredDataForExport), // Usar os dados formatados para exportação
              valoresExibidos,
              fieldObjectProdutosDaf,
              'sisaf_produtos_daf.xlsx',
              userID,
              'DAF', // Nome da interface
              entity, // Nome da entidade
            )
          }
          inserir
          inserirDisabled={!canInsert}
          onClickInserir={handleClickInserir}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default ProdutosIndex;
